/* RIFTED — Theme JS | Away From Home */
(function () {
  'use strict';

  var BAR_KEY = 'rf_bar_dismissed';

  /* ─── Topbar dismiss ─────────────────────────────────── */
  var topbar = document.querySelector('.topbar');
  var topClose = document.querySelector('.topbar-close');
  if (topbar && sessionStorage.getItem(BAR_KEY)) {
    topbar.classList.add('hidden');
    var hdrEl = document.querySelector('.site-header');
    if (hdrEl) hdrEl.classList.add('bar-gone');
    document.body.classList.add('bar-gone');
    document.documentElement.style.setProperty('--bar-h', '0px');
  }
  if (topClose && topbar) {
    topClose.addEventListener('click', function () {
      topbar.classList.add('hidden');
      sessionStorage.setItem(BAR_KEY, '1');
      var hdr = document.querySelector('.site-header');
      if (hdr) hdr.classList.add('bar-gone');
      document.body.classList.add('bar-gone');
      // Update CSS variable so search drawer repositions immediately
      document.documentElement.style.setProperty('--bar-h', '0px');
    });
  }

  /* ─── Header scroll state ────────────────────────────── */
  var hdr = document.querySelector('.site-header');
  if (hdr) {
    var onScroll = function () { hdr.classList.toggle('scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ─── Mobile nav ─────────────────────────────────────── */
  var ham = document.querySelector('.hamburger');
  var drawer = document.querySelector('.mobile-drawer');
  if (ham && drawer) {
    ham.addEventListener('click', function () {
      var open = ham.classList.toggle('open');
      drawer.classList.toggle('open', open);
      ham.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) {
        ham.classList.remove('open');
        drawer.classList.remove('open');
        ham.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });
  }

  /* ─── HERO: Scroll-scrubbed video ───────────────────── */
  var heroRoot   = document.querySelector('.hero-root');
  var heroVideo  = document.getElementById('hero-video');
  var scenes     = document.querySelectorAll('.scene');
  var marquee    = document.querySelector('.marquee-belt');
  var progBar    = document.querySelector('.hero-progress');
  var scrollHint = document.querySelector('.scroll-hint');
  var wordmark   = document.querySelector('.logo-wordmark');
  var logoTag    = document.querySelector('.logo-tag');

  /* Logo entrance */
  if (wordmark) {
    setTimeout(function () {
      wordmark.classList.add('loaded');
      if (logoTag) logoTag.classList.add('loaded');
    }, 180);
  }

  /* ── Video scrubber (hardened for mobile/Safari/slow networks) ────────
     - Waits for canplay before engaging (handles iOS preload ignore)
     - Falls back to gradient bg if video fails or times out after 4s
     - rAF loop drives currentTime at 60fps while scrolling
     - Cleans up gracefully when hero leaves viewport
  ─────────────────────────────────────────────────── */
  if (heroVideo && heroRoot) {

    var rafId       = null;
    var stopTimer   = null;
    var duration    = 0;
    var isReady     = false;
    var loadTimeout = null;

    /* Fallback: gradient if video never loads */
    function videoFailed() {
      clearTimeout(loadTimeout);
      heroVideo.style.display = 'none';
      heroRoot.style.background = 'linear-gradient(160deg,#0a0a0f 0%,#0e0e16 40%,#080810 100%)';
    }

    /* Called once browser has decoded enough to seek anywhere */
    function onReady() {
      clearTimeout(loadTimeout);
      duration = heroVideo.duration || 0;
      if (!duration || duration === Infinity) return;
      isReady = true;
      heroVideo.currentTime = 0;
      scrubToScroll(window.scrollY);
    }

    heroVideo.addEventListener('canplay',      onReady);
    heroVideo.addEventListener('canplaythrough', onReady);
    heroVideo.addEventListener('error',        videoFailed);
    if (heroVideo.readyState >= 3) onReady();

    /* 4s timeout — if nothing loaded on slow connection, show fallback */
    loadTimeout = setTimeout(function () { if (!isReady) videoFailed(); }, 4000);

    /* Kick iOS into loading (it ignores preload="auto") */
    try { heroVideo.load(); } catch(e) {}

    /* Map scrollY → video.currentTime */
    function scrubToScroll(sy) {
      if (!isReady || duration === 0) return;
      var rootTop    = heroRoot.offsetTop;
      var rootHeight = heroRoot.offsetHeight - window.innerHeight;
      if (rootHeight <= 0) return;
      var pct = Math.min(1, Math.max(0, (sy - rootTop) / rootHeight));
      heroVideo.currentTime = Math.min(pct * duration, duration - 0.04);
    }

    /* rAF scrub loop */
    function driveLoop() {
      scrubToScroll(window.scrollY);
      rafId = requestAnimationFrame(driveLoop);
    }
    function startScrub() {
      if (!isReady || rafId) return;
      rafId = requestAnimationFrame(driveLoop);
    }
    function stopScrub() {
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
    }

    window.addEventListener('scroll', function () {
      var sy      = window.scrollY;
      var rTop    = heroRoot.offsetTop;
      var rBottom = rTop + heroRoot.offsetHeight;
      var inHero  = sy < rBottom && (sy + window.innerHeight) > rTop;

      if (inHero && isReady) {
        startScrub();
        clearTimeout(stopTimer);
        stopTimer = setTimeout(stopScrub, 150);
      } else if (!inHero) {
        stopScrub();
      }

      if (scrollHint) scrollHint.classList.toggle('gone', sy > 60);

      if (progBar && heroRoot.offsetHeight > 0) {
        var h   = heroRoot.offsetHeight - window.innerHeight;
        var pct = h > 0 ? Math.min(100, Math.max(0, ((sy - rTop) / h) * 100)) : 0;
        progBar.style.width = pct + '%';
      }
    }, { passive: true });

    if (document.readyState === 'complete') {
      scrubToScroll(window.scrollY);
    } else {
      window.addEventListener('load', function () { scrubToScroll(window.scrollY); });
    }
  }

  /* ── Text scene IntersectionObserver ──────────────────── */
  if ('IntersectionObserver' in window && scenes.length) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var inner = entry.target.querySelector('.scene-inner');
        if (!inner) return;
        if (entry.isIntersecting) {
          scenes.forEach(function (s) {
            var si = s.querySelector('.scene-inner');
            if (si && si !== inner && si.classList.contains('visible')) {
              si.classList.remove('visible');
              si.classList.add('exiting');
              var t = si;
              setTimeout(function () { t.classList.remove('exiting'); }, 500);
            }
          });
          inner.classList.remove('exiting');
          inner.classList.add('visible');
        }
      });
    }, { rootMargin: '-18% 0px -18% 0px', threshold: 0.25 });
    scenes.forEach(function (s) { obs.observe(s); });
  } else {
    scenes.forEach(function (s) {
      var i = s.querySelector('.scene-inner');
      if (i) i.classList.add('visible');
    });
  }

  /* Marquee entrance */
  if (marquee && 'IntersectionObserver' in window) {
    var mObs = new IntersectionObserver(function (ents) {
      if (ents[0].isIntersecting) { marquee.classList.add('visible'); mObs.disconnect(); }
    }, { threshold: 0.3 });
    mObs.observe(marquee);
  } else if (marquee) {
    marquee.classList.add('visible');
  }

  /* ─── Product page: thumbnails ───────────────────────── */
  var mainImgEl = document.getElementById('pdp-photo');
  var thumbBtns = document.querySelectorAll('.pdp-thumb');
  if (mainImgEl && thumbBtns.length) {
    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.dataset.src;
        if (src) mainImgEl.src = src;
        thumbBtns.forEach(function (b) { b.classList.remove('on'); });
        btn.classList.add('on');
      });
    });
  }

  /* ─── Variant selection ──────────────────────────────── */
  var optBtns   = document.querySelectorAll('.opt-btn');
  var atcBtn    = document.querySelector('.atc');
  var varJson   = document.getElementById('variants-json');
  var variants  = varJson ? JSON.parse(varJson.textContent) : [];

  optBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pos = btn.dataset.pos;
      document.querySelectorAll('.opt-btn[data-pos="' + pos + '"]')
        .forEach(function (b) { b.classList.remove('sel'); });
      btn.classList.add('sel');
      syncVariant();
    });
  });

  function selectedOpts() {
    var o = {};
    document.querySelectorAll('.opt-btn.sel').forEach(function (b) { o[b.dataset.pos] = b.dataset.val; });
    return o;
  }
  function syncVariant() {
    if (!variants.length) return;
    var opts = selectedOpts();
    var v = variants.find(function (x) {
      return x.options.every(function (val, i) { return opts[String(i + 1)] === val; });
    });
    if (!v) return;
    if (atcBtn) {
      atcBtn.dataset.vid = v.id;
      atcBtn.disabled = !v.available;
      atcBtn.querySelector('.atc-txt').textContent = v.available
        ? (atcBtn.dataset.add || 'Add to Cart')
        : (atcBtn.dataset.sold || 'Sold Out');
    }
    var priceEl = document.querySelector('.pdp-price');
    if (priceEl && v.price) priceEl.textContent = fmtMoney(v.price);
    var wasEl = document.querySelector('.pdp-was');
    if (wasEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        wasEl.textContent = fmtMoney(v.compare_at_price);
        wasEl.style.display = '';
      } else { wasEl.style.display = 'none'; }
    }
    var mainPriceEl = document.querySelector('.pdp-price');
    if (mainPriceEl) mainPriceEl.classList.toggle('sale', v.compare_at_price > v.price);
  }

  function fmtMoney(c) {
    return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ─── Add to Cart ────────────────────────────────────── */
  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      var vid = atcBtn.dataset.vid;
      if (!vid || atcBtn.disabled) return;
      var txtEl = atcBtn.querySelector('.atc-txt');
      var orig = txtEl ? txtEl.textContent : '';
      atcBtn.classList.add('loading');
      atcBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          atcBtn.classList.remove('loading');
          if (txtEl) txtEl.textContent = 'Added!';
          setTimeout(function () {
            if (txtEl) txtEl.textContent = orig;
            atcBtn.disabled = false;
          }, 2200);
          return fetch('/cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(updateBadge)
        .catch(function () {
          atcBtn.classList.remove('loading');
          if (txtEl) txtEl.textContent = orig;
          atcBtn.disabled = false;
        });
    });
  }

  /* ─── Quick add (grid) ───────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.prod-qadd');
    if (!btn) return;
    e.preventDefault();
    var vid = btn.dataset.vid;
    if (!vid) return;
    var orig = btn.textContent;
    btn.disabled = true; btn.textContent = '...';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Added';
        setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1800);
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(updateBadge)
      .catch(function () { btn.textContent = orig; btn.disabled = false; });
  });

  function updateBadge(cart) {
    document.querySelectorAll('.cart-badge').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('zero', cart.item_count === 0);
    });
  }

  /* ─── Cart page ──────────────────────────────────────── */
  var cartLines = document.querySelector('.cart-lines');
  if (cartLines) {
    cartLines.addEventListener('click', function (e) {
      var qb  = e.target.closest('.qty-b');
      var rm  = e.target.closest('.cart-rm');
      if (qb) {
        var key = qb.dataset.key;
        var vEl = cartLines.querySelector('.qty-v[data-key="' + key + '"]');
        if (!vEl) return;
        var cur = parseInt(vEl.textContent) || 1;
        var next = qb.dataset.act === 'plus' ? cur + 1 : Math.max(0, cur - 1);
        vEl.textContent = next;
        cartChange(key, next);
      }
      if (rm) {
        var rkey = rm.dataset.key;
        cartChange(rkey, 0, function () {
          var row = cartLines.querySelector('[data-key="' + rkey + '"]');
          if (row) row.remove();
        });
      }
    });
  }

  function cartChange(key, qty, cb) {
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateBadge(cart);
        var sub = document.querySelector('.cart-subtotal');
        if (sub) sub.textContent = fmtMoney(cart.total_price);
        if (cb) cb();
      });
  }

})();

/* ── Search drawer ─────────────────────────────── */
(function () {
  var toggle = document.getElementById('search-toggle');
  var drawer = document.getElementById('search-drawer');
  var closeBtn = document.getElementById('search-close');
  var scrim = document.getElementById('search-scrim');
  var input = document.getElementById('search-input');
  if (!toggle || !drawer) return;

  function openSearch() {
    drawer.classList.add('open');
    scrim && scrim.classList.add('visible');
    toggle.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    setTimeout(function () { if (input) input.focus(); }, 60);
  }
  function closeSearch() {
    drawer.classList.remove('open');
    scrim && scrim.classList.remove('visible');
    toggle.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    toggle.focus();
  }

  toggle.addEventListener('click', function () {
    drawer.classList.contains('open') ? closeSearch() : openSearch();
  });
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  if (scrim) scrim.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('open')) closeSearch();
  });
})();

/* ── Account tabs ──────────────────────────────── */
(function () {
  var tabs = document.querySelectorAll('.acct-tab');
  var panels = document.querySelectorAll('.acct-panel');
  if (!tabs.length) return;
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.dataset.tab;
      tabs.forEach(function (t) {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      panels.forEach(function (p) {
        p.classList.remove('active');
        p.hidden = true;
      });
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');
      var panel = document.getElementById('tab-' + target);
      if (panel) { panel.classList.add('active'); panel.hidden = false; }
    });
  });
  // Init hidden state
  panels.forEach(function (p) {
    if (!p.classList.contains('active')) p.hidden = true;
  });
})();

/* ── Address delete confirm ────────────────────── */
(function () {
  document.querySelectorAll('[data-method="delete"]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var msg = btn.dataset.confirm || 'Delete this address?';
      if (!confirm(msg)) return;
      var form = document.createElement('form');
      form.method = 'post';
      form.action = btn.dataset.href;
      var inp = document.createElement('input');
      inp.type = 'hidden'; inp.name = '_method'; inp.value = 'delete';
      form.appendChild(inp);
      document.body.appendChild(form);
      form.submit();
    });
  });
})();
